import React, { useContext } from "react";
import { AppConfigContext } from "../../context/AppConfigContext";
import { getValue } from "../../utils";
import usePreciario from "../../hooks/usePreciario";

const PreciarioHeader = ({ editMode, showAcumulados }) => {
  const appconfig = useContext(AppConfigContext);
  const { view, estimacion } = usePreciario();

  const showEstimaciones = view === "estimaciones";

  const renderHeaders = () => {
    if (editMode !== "partidas") {
      return (
        <>
          <th>Cantidad</th>
          <th>Precio</th>
          {getValue(appconfig, "costs_enabled", "boolean") && <th>$ Costo</th>}
          <th>Importe</th>
          {getValue(appconfig, "subconceptos_enabled", "boolean") && (
            <th>Acciones</th>
          )}
        </>
      );
    }
  };

  const renderEstimacion = () => {
    if (
      String(editMode).includes("conceptos-") &&
      editMode !== "conceptos-extra"
    ) {
      if (estimacion === null) {
        return (
          <>
            <th>Destajo</th>
            <th>Acciones</th>
          </>
        );
      }
      return (
        <>
          <th className="border-0 ps-3">Estimado Anterior</th>
          <th className="border-0">Estimado Actual</th>
          {getValue(appconfig, "editable_prices", "boolean") && (
            <th className="border-0">$PU Estimado</th>
          )}
          {getValue(appconfig, "costs_enabled", "boolean") && (
            <th className="border-0">$Costo Estimado</th>
          )}
          <th className="border-0">Estimado Acumulado</th>
          {getValue(appconfig, "supervise_estimates", "boolean") && [
            <th key="supervisado-anterior" className="border-0">
              Supervisado Anterior
            </th>,
            <th key="supervisado-actual" className="border-0">
              Supervisado Actual
            </th>,
            <th key="supervisado-acumulado" className="border-0">
              Supervisado Acumulado
            </th>,
          ]}
          {getValue(appconfig, "authorize_estimates", "boolean") && [
            <th key="autorizado-anterior" className="border-0">
              Autorizado Anterior
            </th>,
            <th key="autorizado-actual" className="border-0">
              Autorizado Actual
            </th>,
            <th key="autorizado-acumulado" className="border-0">
              Autorizado Acumulado
            </th>,
            <th key="precio-acumulado" className="border-0">
              P$ Autorizado
            </th>,
          ]}
          <th className="border-0">
            Importe{" "}
            {getValue(appconfig, "authorize_estimates", "boolean")
              ? "Autorizado"
              : ""}
          </th>
          <th className="border-0">Evidencia</th>
        </>
      );
    }
    if (
      showEstimaciones &&
      (editMode === null || editMode === "conceptos-estimacion")
    ) {
      return (
        <>
          <th className="border-0 ps-3 bg-secondary">Estimado</th>
          {getValue(appconfig, "supervise_estimates", "boolean") && (
            <th className="border-0 bg-secondary">Supervisado</th>
          )}
          {getValue(appconfig, "authorize_estimates", "boolean") && (
            <th className="border-0 bg-secondary">Autorizado</th>
          )}
          <th className="border-0 bg-secondary">Importe</th>
          {/*<th className="border-0 bg-secondary">Evidencia</th>*/}
          <th className="border-0 bg-secondary">Acumulado</th>
          <th className="border-0 bg-secondary">Dif. Real</th>
          <th className="border-0 bg-secondary">Ejecutado(%)</th>
        </>
      );
    }
    if (showAcumulados) {
      return (
        <>
          <th className="border-0 bg-secondary">Estimado</th>
          <th className="border-0 bg-secondary">Autorizado</th>
          <th className="border-0 bg-secondary">Ejecutado(%)</th>
        </>
      );
    }
  };

  return (
    <thead className="border-bottom">
      <tr>
        <th style={{ minWidth: 80 }}>Clave</th>
        <th className="nombre-concepto">Concepto</th>
        {["partidas", "conceptos"].includes(editMode) && <th>Cronograma</th>}
        {editMode !== "partidas" && <th>Unidad</th>}
        {renderHeaders()}
        {editMode === "partidas" &&
          getValue(appconfig, "subconceptos_enabled", "boolean") && (
            <th>Acciones</th>
          )}
        {renderEstimacion()}
      </tr>
    </thead>
  );
};

export default PreciarioHeader;
